"use client";

import { useState, useEffect } from "react";

/**
 * Returns true if viewport width is less than or equal to the given breakpoint
 * Uses max-width internally, so useMediaQuery(768) = true when width <= 768px
 */
export function useMediaQuery(maxWidth: number): boolean {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setMatches(e.matches);
    };

    // Set initial value
    handleChange(query);

    // Listen for changes
    query.addEventListener("change", handleChange);
    return () => {
      query.removeEventListener("change", handleChange);
    };
  }, [maxWidth]);
  return matches;
}